import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RedirectWebsite } from '../../../core/constants/user/redirect-website';
import { IUserInformation } from '../../../core/interfaces/user/user-information';
import { LocalStorageService } from '../../../core/services/local-storage.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  public redirectWebsite = RedirectWebsite.Url;
  public userRole: string = "customer";
  public userInfo: IUserInformation = null;

 
  constructor(private title: Title,
    private localStorageService: LocalStorageService) {
    this.title.setTitle("Dillo Docs | AI");
    this.userInfo = this.localStorageService.getUserInfo();

    if (this.userInfo != null && this.userInfo.userRole != null) {
      this.userRole = this.userInfo.userRole.toLowerCase();
    }

  }

  ngOnInit() {
  }


  
}
